<div #template><ng-content></ng-content></div>